import { InputNumber, InputNumberProps } from 'antd'
import { handleKeyDownNumberOnly } from '@/utils/helpers/inputHelper'
import { inputNumberParser } from '@/utils/helpers/inputHelper'
export const InputNumberStyled = ({
  className,
  ...props
}: InputNumberProps) => (
  <InputNumber
    onKeyDown={handleKeyDownNumberOnly}
    className={className}
    parser={inputNumberParser}
    min={0}
    controls={false}
    {...props}
  />
)
